"use client";

import { FC, useEffect } from "react";
import { useForm, ValidationError } from "@formspree/react";
import { ToastContainer } from "react-toastify";
import { showErrorToast, showSuccessToast } from "@/components/Toast/Toast";

const Contact: FC = () => {
	const formspreeId = process.env.NEXT_PUBLIC_FORMSPREE_ID;
	const [state, handleSubmit] = useForm(
		formspreeId || "missing-formspree-id",
	);

	useEffect(() => {
		if (state.succeeded) {
			showSuccessToast("Thank you for contacting us!");
		}
	}, [state.succeeded]);

	useEffect(() => {
		if (state.errors && Object.keys(state.errors).length) {
			showErrorToast(
				"Unable to send email. Please try directly emailing us at contact@spanda.life",
			);
		}
	}, [state.errors]);

	if (state.succeeded) {
		return (
			<div className="flex items-center justify-center min-h-[300px] text-center">
				<p className="text-xl font-semibold text-gray-800">
					🎉 Thank you for your message. We’ll get back to you soon!
				</p>
			</div>
		);
	}

	return (
		<form onSubmit={handleSubmit} className="mx-auto w-full max-w-md">
			<div className="mb-2">
				<label
					htmlFor="name"
					className="mb-3 block text-base font-medium text-black"
				>
					Full Name
				</label>
				<input
					id="name"
					type="text"
					name="name"
					required
					className="w-full rounded-md border border-gray-300 bg-white px-6 py-3 
          text-base font-medium text-gray-700 outline-none focus:border-purple-500 focus:shadow-md"
				/>
				<ValidationError prefix="Name" field="name" errors={state.errors} />
			</div>

			<div className="mb-5">
				<label
					htmlFor="email"
					className="mb-3 block text-base font-medium text-black"
				>
					Email Address
				</label>
				<input
					id="email"
					type="email"
					name="email"
					required
					className="w-full rounded-md border border-gray-300 bg-white px-6 py-3 
          text-base font-medium text-gray-700 outline-none focus:border-purple-500 focus:shadow-md"
				/>
				<ValidationError prefix="Email" field="email" errors={state.errors} />
			</div>

			<div className="mb-5 relative">
				<label
					htmlFor="message"
					className="mb-3 block text-base font-medium text-black"
				>
					Message
				</label>
				<textarea
					id="message"
					name="message"
					rows={4}
					maxLength={250}
					required
					className="w-full resize-none rounded-md border border-gray-300 bg-white px-6 py-3 
          text-base font-medium text-gray-700 outline-none focus:border-purple-500 focus:shadow-md"
				/>
				<ValidationError prefix="Message" field="message" errors={state.errors} />
			</div>

			<div>
				<button
					type="submit"
					disabled={state.submitting || !formspreeId}
					className="hover:shadow-form rounded-md bg-saintiantblue px-8 py-3 
          text-base font-semibold text-white outline-none disabled:opacity-50"
				>
					{state.submitting ? "Sending..." : "Submit"}
				</button>
				{!formspreeId && (
					<p className="mt-3 text-sm text-gray-600">
						Email us directly at{" "}
						<a className="font-medium underline" href="mailto:contact@spanda.life">
							contact@spanda.life
						</a>
						.
					</p>
				)}
			</div>
			<ToastContainer style={{ marginTop: "80px" }} />
		</form>
	);
};

export default Contact;
